import {Button, Col, Form, FormGroup, Input, InputGroup, InputGroupText, Row} from "reactstrap";
import React from "react";
import withNavigateHook from '../../hooks/withNavigationHook';
import {RiBankCardLine, RiDraftLine} from "react-icons/ri";
import {updateUser} from "../../components/helpers/UserHelpers";
import Api from "../../components/helpers/Api";

class YourDetailsForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formSubmitted: false,
            firstName: JSON.parse(sessionStorage.getItem("customer")).user.firstName,
            lastName: JSON.parse(sessionStorage.getItem("customer")).user.lastName,
            email: JSON.parse(sessionStorage.getItem("customer")).user.email,
            firstNameError: "",
            lastNameError: "",
            emailError: "",
            generalError: "",
            resolvedRole: null,
            accountResolved: false,
        }
    }


    componentDidMount() {
        const sessionUser = JSON.parse(sessionStorage.getItem("customer"))?.user;
        Api.get("/api/account/me")
            .then(() => Api.get("/api/account/members"))
            .then(res => {
                const members = res.data || [];
                const currentMember = members.find(m => m.userId === sessionUser?.id);
                const resolvedRole = currentMember?.role ?? sessionUser?.accountRole ?? null;
                this.setState({ accountResolved: true, resolvedRole });
            })
            .catch(err => {
                if (err.response?.status === 404) {
                    // No group account — Individual user
                    this.setState({ accountResolved: true, resolvedRole: null });
                } else {
                    // Network error or other failure — fall back to session
                    this.setState({ accountResolved: true, resolvedRole: sessionUser?.accountRole ?? null });
                }
            });
    }
    
    onChangeEmail = (e) => {
        this.setState({
            email: e.target.value,
            emailError: "",
        });
    };

    onChangeFirstName = (e) => {
        this.setState({
            firstName: e.target.value,
            firstNameError: "",
        });
    };

    onChangeLastName = (e) => {
        this.setState({
            lastName: e.target.value,
            lastNameError: "",
        });
    };

    validateAndSubmitForm = async () => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        this.setState({formSubmitted: true});
        let formHasError = false;

        if (!this.state.firstName || this.state.firstName.trim().length === 0) {
            this.setState({firstNameError: "* You must provide a first name"})
            formHasError = true;
        }
        if (!this.state.lastName || this.state.lastName.trim().length === 0) {
            this.setState({lastNameError: "* You must provide a last name"})
            formHasError = true;
        }
        if (!this.state.email || this.state.email.trim().length === 0 || !emailRegex.test(this.state.email)) {
            this.setState({emailError: "* You must provide an email address"})
            formHasError = true;
        }

        if (!formHasError) {
            updateUser(this.state.firstName, this.state.lastName, this.state.email).then(result => {
                if (result) {
                    sessionStorage.setItem("customer", JSON.stringify(result));
                    this.setState({formSubmitted:  true});
                    this.props.navigation(0);
                }
            });
        } else {
            this.setState({formSubmitted:  true});
        }
    }

    updateButtonAvailable = () => {
        const firstNameChanged = (this.state.firstName && this.state.firstName !== JSON.parse(sessionStorage.getItem("customer")).user.firstName);
        const lastNameChanged = (this.state.lastName && this.state.lastName !== JSON.parse(sessionStorage.getItem("customer")).user.lastName);
        const emailChanged = (this.state.email && this.state.email !== JSON.parse(sessionStorage.getItem("customer")).user.email);
        const formSubmitted = this.state.formSubmitted === true;

        const buttonAvailable = firstNameChanged || lastNameChanged || emailChanged || formSubmitted;

        return buttonAvailable;
    }

    render() {
        return (
            <>
                 <Form role="form">
                     <FormGroup>
                         <Row lg="12">
                             <Col lg="12">
                                 <InputGroup className="input-group-alternative mb-3">
                                     {/*<InputGroupAddon addonType="prepend">*/}
                                         <InputGroupText>
                                             <RiDraftLine />
                                         </InputGroupText>
                                     {/*</InputGroupAddon>*/}
                                     <Input
                                         placeholder="FirstName"
                                         type="text"
                                         autoComplete="off"
                                         onChange={this.onChangeFirstName}
                                         value={this.state.firstName}
                                     />
                                 </InputGroup>
                             </Col>
                         </Row>
                         <Row lg="12">
                             <Col lg="12">
                                 <span className="text-danger">{this.state.firstNameError}</span>
                             </Col>
                         </Row>
                     </FormGroup>
                     <FormGroup>
                         <Row lg="12">
                             <Col lg="12">
                                 <InputGroup className="input-group-alternative mb-3">
                                     {/*<InputGroupAddon addonType="prepend">*/}
                                         <InputGroupText>
                                             <RiDraftLine />
                                         </InputGroupText>
                                     {/*</InputGroupAddon>*/}
                                     <Input
                                         placeholder="LastName"
                                         type="text"
                                         autoComplete="off"
                                         onChange={this.onChangeLastName}
                                         value={this.state.lastName}
                                     />
                                 </InputGroup>
                             </Col>
                         </Row>
                         <Row lg="12">
                             <Col lg="12">
                                 <span className="text-danger">{this.state.lastNameError}</span>
                             </Col>
                         </Row>
                     </FormGroup>
                     <FormGroup>
                         <Row lg="12">
                             <Col lg="12">
                                 <InputGroup className="input-group-alternative mb-3">
                                     {/*<InputGroupAddon addonType="prepend">*/}
                                         <InputGroupText>
                                             <i className="ni ni-email-83" />
                                         </InputGroupText>
                                     {/*</InputGroupAddon>*/}
                                     <Input
                                        placeholder="Email"
                                        type="email"
                                        maxLength="200"
                                        onChange={this.onChangeEmail}
                                        value={this.state.email}
                                     />
                                 </InputGroup>
                             </Col>
                         </Row>
                         <Row lg="12">
                             <Col lg="12">
                                 <span className="text-danger">{this.state.emailError}</span>
                             </Col>
                         </Row>
                     </FormGroup>
                     <Row lg="12">
                         <Col lg="12">
                             <span className="text-danger">{this.state.generalError}</span>
                         </Col>
                     </Row>
                     <Row>
                         <Col className="float-left">
                             <Button
                                id="loginButton"
                                className="mt-4"
                                color="primary"
                                type="button"
                                style={{ width: "100%" }}
                                onClick={this.validateAndSubmitForm}
                                disabled={!this.updateButtonAvailable()}
                             >
                                 Save changes
                             </Button>
                         </Col>
                     </Row>
                     <Row>
                         {this.state.accountResolved && (() => {
                             const role = this.state.resolvedRole;
                             const isSingleUser = role === null;
                             const canViewGroup = role === "OWNER" || role === "ADMIN";
                             const canViewBilling = isSingleUser || role === "OWNER";
                             const canUpgradeToEnterprise = role === "OWNER";
                             return (
                                 <>
                                     {canViewGroup && (
                                         <Col className="float-right">
                                             <Button
                                                 className="mt-4"
                                                 color="primary"
                                                 type="button"
                                                 style={{ width: "100%" }}
                                                 href="/your-profile/team"
                                             >
                                                 View Your Group
                                             </Button>
                                         </Col>
                                     )}
                                     {canViewBilling && (
                                         <Col className="float-right">
                                             <Button
                                                 className="mt-4"
                                                 color="primary"
                                                 type="button"
                                                 style={{ width: "100%" }}
                                                 href="/your-profile/billing-details"
                                             >
                                                 View Billing Details
                                             </Button>
                                         </Col>
                                     )}
                                     {canUpgradeToEnterprise && (
                                         <Col className="float-right">
                                             <Button
                                                 className="mt-4"
                                                 color="secondary"
                                                 type="button"
                                                 style={{ width: "100%" }}
                                                 href="/your-profile/enterprise/upgrade"
                                             >
                                                 Upgrade to Organisation
                                             </Button>
                                         </Col>
                                     )}
                                     {isSingleUser && (
                                         <Col className="float-right">
                                             <Button
                                                 className="mt-4"
                                                 color="primary"
                                                 type="button"
                                                 style={{ width: "100%" }}
                                                 href="/your-profile/team/upgrade"
                                             >
                                                 Upgrade to Group
                                             </Button>
                                         </Col>
                                     )}
                                     {isSingleUser && (
                                         <Col className="float-right">
                                             <Button
                                                 className="mt-4"
                                                 color="primary"
                                                 type="button"
                                                 style={{ width: "100%" }}
                                                 href="/your-profile/enterprise/upgrade"
                                             >
                                                 Upgrade to Organisation
                                             </Button>
                                         </Col>
                                     )}
                                 </>
                             );
                         })()}
                     </Row>
                     <Row>
                         <Col className="float-left">
                             <Button
                                 id="loginButton"
                                 className="mt-4"
                                 color="primary"
                                 type="button"
                                 style={{ width: "100%" }}
                                 href="/your-preferences/song-books"
                             >
                                 Your song book preferences
                             </Button>
                         </Col>
                     {/*    <Col className="float-right">*/}
                     {/*        <Button*/}
                     {/*            id="loginButton"*/}
                     {/*            className="mt-4"*/}
                     {/*            color="primary"*/}
                     {/*            type="button"*/}
                     {/*            style={{ width: "100%" }}*/}
                     {/*            href="/your-preferences/themes"*/}
                     {/*        >*/}
                     {/*            Your theme preferences*/}
                     {/*        </Button>*/}
                     {/*    </Col>*/}
                     </Row>
                 </Form>
            </>
        );
    }
}


export default withNavigateHook(YourDetailsForm);
